import React, { useContext, useState, useEffect } from "react";
import {
  Stack,
  Box,
  Grid2 as Grid,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Tooltip,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";

//Icons
import { BiMinusCircle } from "react-icons/bi";

//Srcs
import "../../Style/dialogStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { DEPLICATE_CLASS } from "../../Schema/Class";

import {
  SelectAcademicYear,
  SelectSchool,
  SelectGroup,
  SelectLevel,
  SelectTeacher,
} from "../../Function/DynamicSelect";

export default function DuplicateClass({
  open,
  handleClose,
  setRefetch,
}) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  const [oldAcademicYearVal, setOldAcademicYearVal] = useState({ id: "", title: "" });
  const [newAcademicYearVal, setNewAcademicYearVal] = useState({ id: "", title: "" });


  //======================== Create User =========================
  const [dulpicateClass] = useMutation(DEPLICATE_CLASS, {
    onCompleted: ({ dulpicateClass }) => {
      // console.log("dulpicateClass", dulpicateClass);
      setLoading(false);
      if (dulpicateClass?.is_success === true) {
        setAlert(true, "success", dulpicateClass?.message);
        handleClose();
        resetForm();
        setRefetch();
        setNewAcademicYearVal({ id: "", title: "" })
        setOldAcademicYearVal({ id: "", title: "" })
      } else {
        setAlert(true, "error", dulpicateClass?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    academicYearId: Yup.string().required(t("require")),
    newAcademicYearId: Yup.string().required(t("require")),
  });

  const formik = useFormik({
    initialValues: {
      academicYearId: "",
      newAcademicYearId: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      dulpicateClass({
        variables: {
          academicYearId: values?.academicYearId,
          newAcademicYearId: values?.newAcademicYearId,
        },
      });
    },
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  useEffect(() => {
    setFieldValue("academicYearId", oldAcademicYearVal?.id ?? "");
  }, [oldAcademicYearVal?.id]);
  useEffect(() => {
    setFieldValue("newAcademicYearId", newAcademicYearVal?.id ?? "");
  }, [newAcademicYearVal?.id]);

  useEffect(() => {
    resetForm();
    setNewAcademicYearVal({ id: "", title: "" })
    setOldAcademicYearVal({ id: "", title: "" })
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography
              className={language === "en" ? "dialog-title" : "dialog-title-kh"}
            >
              {t("dialog_title_duplicate_class")}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("old_academic_year")}
                </Typography>
                <SelectAcademicYear
                  selectedVal={oldAcademicYearVal}
                  setSelectedVal={setOldAcademicYearVal}
                />
                {!!errors.academicYearId && touched.academicYearId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.academicYearId}
                  </FormHelperText>
                )}
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Typography
                  className={
                    language === "en" ? "field-title" : "field-title-kh"
                  }
                >
                  {t("new_academic_year")}
                </Typography>
                <SelectAcademicYear
                  selectedVal={newAcademicYearVal}
                  setSelectedVal={setNewAcademicYearVal}
                />
                {!!errors.newAcademicYearId && touched.newAcademicYearId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.newAcademicYearId}
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
      <DialogActions sx={{ border: "none" }}>
        <Box className="create-container">
          <Grid container>
            <Grid size={{ xs: 12 }}>
              {loading ? (
                <Button
                  className={language === "kh" ? "btn-create-kh" : "btn-create"}
                  fullWidth
                >
                  {t("loading")}
                </Button>
              ) : (
                <Button
                  className={language === "kh" ? "btn-create-kh" : "btn-create"}
                  fullWidth
                  onClick={handleSubmit}
                >
                  {t("btn-create")}
                </Button>
              )}
            </Grid>
          </Grid>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
